<template>
  <div
    class="vertical-layout h-100"
    :class="[layoutClasses, { 'is-moments-route': $route.name === 'moments', 'has-campaign-pill': showCampaignPill, 'has-app-footer': !isFooterHiddenRoute }]"
    :data-col="isNavMenuHidden ? '1-column' : null"
  >
    <!-- Tab Bar -->
    <div v-if="showCampaignPill" class="tab-bar-top-container">
      <div class="tab-bar-top">
        <RouterLink :to="{name: 'campaigns'}">
          <svg width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32.3 14.1429H28.9C28.4183 14.1429 28.0149 13.9852 27.6896 13.6698C27.3643 13.3543 27.2011 12.9644 27.2 12.5C27.1989 12.0356 27.3621 11.6457 27.6896 11.3302C28.0171 11.0148 28.4206 10.8571 28.9 10.8571H32.3C32.7817 10.8571 33.1857 11.0148 33.5121 11.3302C33.8385 11.6457 34.0011 12.0356 34 12.5C33.9989 12.9644 33.8357 13.3549 33.5104 13.6714C33.1851 13.988 32.7817 14.1451 32.3 14.1429ZM24.82 20.3861C25.1033 20.0027 25.4717 19.7837 25.925 19.7289C26.3783 19.6742 26.8033 19.7837 27.2 20.0575L29.92 22.029C30.3167 22.3028 30.5433 22.6588 30.6 23.0969C30.6567 23.535 30.5433 23.9458 30.26 24.3291C29.9767 24.7125 29.6083 24.9315 29.155 24.9863C28.7017 25.0411 28.2767 24.9315 27.88 24.6577L25.16 22.6862C24.7633 22.4124 24.5367 22.0564 24.48 21.6183C24.4233 21.1802 24.5367 20.7694 24.82 20.3861ZM29.92 2.97097L27.2 4.9425C26.8033 5.21632 26.3783 5.32585 25.925 5.27108C25.4717 5.21632 25.1033 4.99726 24.82 4.61391C24.5367 4.23056 24.4233 3.81982 24.48 3.38171C24.5367 2.94359 24.7633 2.58762 25.16 2.3138L27.88 0.342278C28.2767 0.0684554 28.7017 -0.0410734 29.155 0.0136912C29.6083 0.0684557 29.9767 0.287514 30.26 0.670865C30.5433 1.05422 30.6567 1.46495 30.6 1.90307C30.5433 2.34118 30.3167 2.69715 29.92 2.97097ZM5.1 17.4288H3.4C2.465 17.4288 1.66487 17.1073 0.9996 16.4644C0.334333 15.8215 0.00113333 15.0476 0 14.1429V10.8571C0 9.95345 0.3332 9.18017 0.9996 8.53724C1.666 7.8943 2.46613 7.57229 3.4 7.57119H10.2L16.1075 4.12103C16.6742 3.79244 17.2482 3.79244 17.8296 4.12103C18.411 4.44962 18.7011 4.92881 18.7 5.5586V19.4414C18.7 20.0712 18.4093 20.5504 17.8279 20.879C17.2465 21.2076 16.673 21.2076 16.1075 20.879L10.2 17.4288H8.5V22.3576C8.5 22.8231 8.3368 23.2136 8.0104 23.529C7.684 23.8445 7.28053 24.0016 6.8 24.0005C6.31947 23.9995 5.916 23.8417 5.5896 23.5274C5.2632 23.213 5.1 22.8231 5.1 22.3576V17.4288ZM20.4 18.0038V6.99617C21.165 7.65334 21.7815 8.45454 22.2496 9.39978C22.7177 10.345 22.9511 11.3784 22.95 12.5C22.9489 13.6216 22.7148 14.6555 22.2479 15.6019C21.781 16.5482 21.165 17.3489 20.4 18.0038Z" fill="currentColor"/>
          </svg>
          <span class="campaign-pill-label">
            {{ $t('Campaigns') }}
          </span>
          <span
            class="campaign-pill-dot"
            aria-hidden="true"
          />
        </RouterLink>
      </div>
    </div>
    <!-- Mobile Bottom Tab Bar (Rush Navigation on Mobile) -->
    <nav v-if="!shallHideMobileTabBar" class="tab-bar">
      <!-- 1. Keşfet -->
      <router-link
        :to="{ name: 'moments', query: { tab: 'discoverygrid' } }"
        class="tab-link"
        :class="{ active: isExploreActive }"
      >
        <div class="tab-icon-wrapper">
          <svg class="tab-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
          </svg>
        </div>
        <span class="tab-label">{{ $t('Explore') || 'Keşfet' }}</span>
      </router-link>

      <!-- 2. Sana Özel -->
      <router-link
        :to="{ name: 'moments', query: { tab: 'foryou' } }"
        class="tab-link"
        :class="{ active: isForYouActive }"
      >
        <div class="tab-icon-wrapper">
          <svg class="tab-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>
        </div>
        <span class="tab-label">{{ $t('For You') || 'Sana Özel' }}</span>
      </router-link>

      <!-- 3. Moments / Anlar -->
      <router-link
        :to="{ name: 'moments', query: { tab: 'discover' } }"
        class="tab-link"
        :class="{ active: isMomentsActive }"
      >
        <div class="tab-icon-wrapper">
          <svg class="tab-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="3" y1="9" x2="21" y2="9"></line>
            <line x1="9" y1="21" x2="9" y2="9"></line>
          </svg>
        </div>
        <span class="tab-label">Moments</span>
      </router-link>

      <!-- 4. Sohbet -->
      <router-link
        :to="{ name: 'chat' }"
        class="tab-link"
        :class="{ active: isChatActive }"
      >
        <div class="tab-icon-wrapper">
          <svg class="tab-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
          <span v-if="unreadCount > 0" class="tab-badge">{{ unreadCount }}</span>
        </div>
        <span class="tab-label">{{ $t('Chats') || 'Sohbet' }}</span>
      </router-link>

      <!-- 5. Profil -->
      <router-link
        :to="{ name: 'profile.index' }"
        class="tab-link"
        :class="{ active: isProfileActive }"
      >
        <div class="tab-icon-wrapper">
          <svg class="tab-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </div>
        <span class="tab-label">{{ $t('Profile') || 'Profil' }}</span>
      </router-link>
    </nav>
    <!-- /Mobile Bottom Tab Bar -->
    <!-- Tab Bar -->
    <b-navbar
      :toggleable="false"
      :variant="navbarBackgroundColor"
      class="header-navbar navbar navbar-shadow align-items-center"
      :class="[navbarTypeClass]"
    >
      <slot
        name="navbar"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :navbarBackgroundColor="navbarBackgroundColor"
        :navbarTypeClass="[...navbarTypeClass, 'header-navbar navbar navbar-shadow align-items-center']"
      >
        <app-navbar-vertical-layout :toggle-vertical-menu-active="toggleVerticalMenuActive" />
      </slot>
    </b-navbar>
    <!--/ Navbar -->

    <!-- Vertical Nav Menu -->
    <vertical-nav-menu
      v-if="!isNavMenuHidden"
      :is-vertical-menu-active="isVerticalMenuActive"
      :toggle-vertical-menu-active="toggleVerticalMenuActive"
    >
      <template #header="slotProps">
        <slot
          name="vertical-menu-header"
          v-bind="slotProps"
        />
      </template>
    </vertical-nav-menu>
    <!-- /Vertical Nav Menu -->

    <!-- Vertical Nav Menu Overlay -->
    <div
      class="sidenav-overlay"
      :class="overlayClasses"
      @click="isVerticalMenuActive = false"
    />
    <!-- /Vertical Nav Menu Overlay -->

    <!-- Content -->

    <!-- CONTENT TYPE: Left -->
    <transition
      :name="routerTransition"
      mode="out-in"
    >
      <component
        :is="layoutContentRenderer"
        :key="layoutContentRenderer === 'layout-content-renderer-left' ? $route.meta.navActiveLink || $route.name : null"
      >
        <template
          v-for="(index, name) in $scopedSlots"
          v-slot:[name]="data"
        >
          <slot
            :name="name"
            v-bind="data"
          />
        </template>
      </component>
    </transition>
    <!--/ Content -->

    <!-- Floating Promo Button -->
    <FloatingPromoButton />
    <!-- /Floating Promo Button -->

    <!-- Footer -->
    <footer
      v-if="!isFooterHiddenRoute"
      class="footer footer-light app-footer-wrap"
      :class="[footerTypeClass]"
    >
      <slot name="footer">
        <app-footer />
      </slot>
    </footer>
    <!-- /Footer -->

    <slot name="customizer" />
  </div>
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import AppNavbarVerticalLayout from '@core/layouts/components/app-navbar/AppNavbarVerticalLayout.vue'
import AppFooter from '@core/layouts/components/AppFooter.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { BNavbar } from 'bootstrap-vue'
import LayoutContentRendererDefault from '@core/layouts/components/layout-content-renderer/LayoutContentRendererDefault.vue'
import LayoutContentRendererLeft from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeft.vue'
import LayoutContentRendererLeftDetached from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeftDetached.vue'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import useVerticalLayout from './useVerticalLayout'
import mixinVerticalLayout from './mixinVerticalLayout'
import FloatingPromoButton from '@/components/FloatingPromoButton.vue'

export default {
  components: {
    // AppBreadcrumb,
    AppNavbarVerticalLayout,
    AppFooter,
    VerticalNavMenu,
    BNavbar,
    LayoutContentRendererLeftDetached,
    LayoutContentRendererLeft,
    LayoutContentRendererDefault,
    FloatingPromoButton,
  },
  mixins: [mixinVerticalLayout],
  computed: {
    layoutContentRenderer() {
      const rendererType = this.$route.meta.contentRenderer
      if (rendererType === 'sidebar-left') return 'layout-content-renderer-left'
      if (rendererType === 'sidebar-left-detached') return 'layout-content-renderer-left-detached'
      return 'layout-content-renderer-default'
    },
    user() {
      return this.$store.getters['auth/user']
    },
    unreadCount() {
      return this.$store.getters['socket/unreadChatCount'] || 0
    },
    isExploreActive() {
      const exploreRoutes = ['popular-users', 'index', 'discover', 'search-users', 'new-users', 'near-by', 'online-users', 'video-call-users']
      return (this.$route.name === 'moments' && (this.$route.query.tab === 'discoverygrid' || !this.$route.query.tab)) || (exploreRoutes.includes(this.$route.name) && this.$route.name !== 'moments')
    },
    isForYouActive() {
      return this.$route.name === 'for-you' || (this.$route.name === 'moments' && this.$route.query.tab === 'foryou')
    },
    isMomentsActive() {
      return this.$route.name === 'moments' && this.$route.query.tab === 'discover'
    },
    isChatActive() {
      return this.$route.name === 'chat'
    },
    isProfileActive() {
      // Profil sayfası artık Ayarlar > Profil Bilgileri altında; ayarlar sayfalarında da Profil sekmesi aktif kalsın
      return Boolean(this.$route.name && (this.$route.name === 'profile.index' || this.$route.name.startsWith('profile') || this.$route.name.startsWith('settings')))
    },
    // Kampanyalar hapı kapatıldı: kampanyalar sayfası boş olduğu için ekranın ortasında (alt menünün
    // üstünde) boş bir sayfaya giden link olarak çıkıyordu
    showCampaignPill() {
      return false && !['chat', 'market', 'buy', 'payment.finalize', 'moments', 'voice-room', 'video-room', 'video-room-setup', 'voice-room-setup', 'rewards', 'tasks', 'tawk-chat'].includes(this.$route.name)
    },
    isMomentsScreen() {
      return this.$route.name === 'moments' || this.$route.name === 'for-you' || (this.$route.path && this.$route.path.includes('/moments'))
    },
    isFooterHiddenRoute() {
      // Tam ekran çalışan sayfalarda (sohbet, oda, ödeme sonucu, Moments video akışı) footer gösterilmez.
      // Moments sayfasının keşfet ızgarası ve Sana Özel sekmeleri normal kaydırıldığı için footer orada görünür.
      if (this.isMomentsScreen && this.$route.query.tab === 'discover') return true
      return ['chat', 'voice-room', 'video-room', 'video-room-setup', 'voice-room-setup', 'payment.finalize'].includes(this.$route.name)
    },
    shallHideMobileTabBar() {
      return ['voice-room', 'video-room', 'video-room-setup', 'voice-room-setup', 'payment.finalize'].includes(this.$route.name)
    },
  },
  setup() {
    const {
      routerTransition, navbarBackgroundColor, navbarType, footerType, isNavMenuHidden,
    } = useAppConfig()

    const {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      layoutClasses,
      overlayClasses,
      resizeHandler,
      navbarTypeClass,
      footerTypeClass,
    } = useVerticalLayout(navbarType, footerType)

    // Resize handler
    resizeHandler()
    window.addEventListener('resize', resizeHandler)
    onUnmounted(() => {
      window.removeEventListener('resize', resizeHandler)
    })

    return {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      overlayClasses,
      layoutClasses,
      navbarTypeClass,
      footerTypeClass,

      // App Config
      routerTransition,
      navbarBackgroundColor,
      isNavMenuHidden,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/themes/bordered-layout.scss";

// Hide vertical sidebar completely
.main-menu,
.vertical-nav-menu,
.sidenav-overlay {
  display: none !important;
}

.vertical-layout {
  min-height: 100vh !important;
  background: transparent !important;

  .header-navbar.navbar {
    width: 100% !important;
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
    background-color: #11172b !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25) !important;
    padding: 0 1.25rem !important;
    height: 72px !important;
    min-height: 72px !important;
    max-height: 72px !important;
    border-radius: 0 !important;
    z-index: 1030 !important;

    .navbar-container {
      padding: 0 !important;
      height: 72px !important;
    }
  }

  .app-content.content {
    margin-left: 0 !important;
    padding-top: calc(72px + 1.5rem) !important;
    background: transparent !important;
  }

  .content-wrapper,
  .content-body {
    background: transparent !important;
  }

  .app-content.content.chat-application {
    padding-top: calc(72px + 12px) !important;
    padding-bottom: 16px !important;
    height: 100vh;
    height: 100dvh;
    min-height: 0 !important;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: hidden;
    background: transparent !important;

    > .message-information {
      flex: 0 0 auto;
    }

    .content-area-wrapper {
      flex: 1 1 0;
      min-height: 0;
      height: auto !important;
      background: rgba(13, 9, 26, 0.85) !important;
      backdrop-filter: blur(12px) !important;
      border: 1px solid rgba(255, 255, 255, 0.08) !important;
      border-radius: 18px !important;
      overflow: hidden !important;
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.45) !important;
    }

    .content-wrapper {
      padding-bottom: 0 !important;
    }
  }

  &.is-moments-route,
  .app-content.content.moments-application {
    background: transparent !important;
  }

  &.is-moments-route .app-content.content,
  .app-content.content.moments-application {
    padding: 72px 0 0 0 !important;
    margin: 0 !important;
    background: transparent !important;
    min-height: 100vh !important;

    .content-wrapper {
      padding: 0 !important;
      margin: 0 !important;
      background: transparent !important;
      max-width: 100% !important;
    }

    .content-body {
      padding: 0 !important;
      margin: 0 !important;
      background: transparent !important;
    }

    .header-navbar-shadow {
      display: none !important;
    }
  }
}

@media (max-width: 768px) {
  .vertical-layout {
    .header-navbar.navbar {
      height: 64px !important;
      min-height: 64px !important;
      max-height: 64px !important;
      padding: 0 0.75rem !important;

      .navbar-container {
        height: 64px !important;
      }
    }

    .app-content.content {
      padding-top: calc(64px + 1rem) !important;
    }

    .app-content.content.chat-application {
      padding-top: calc(64px + 8px) !important;
      padding-bottom: calc(74px + env(safe-area-inset-bottom, 0px)) !important;
    }

    &.is-moments-route .app-content.content,
    .app-content.content.moments-application {
      padding: 64px 0 calc(68px + env(safe-area-inset-bottom, 0px)) 0 !important;
    }
  }

  .content-wrapper {
    padding-bottom: calc(68px + env(safe-area-inset-bottom, 0px)) !important;
  }

  /* Kampanyalar hapı tab bar'ın üstünde durduğunda içerik onun altında kalmasın */
  .vertical-layout.has-campaign-pill .content-wrapper {
    padding-bottom: calc(140px + env(safe-area-inset-bottom, 0px)) !important;
  }

  /* Yatay taşma / kaymayı engelle */
  .vertical-layout .app-content.content {
    overflow-x: hidden;
  }

  .chat-app-window .chat-app-form {
    bottom: calc(66px + env(safe-area-inset-bottom, 0px)) !important;
  }
}
</style>

<style scoped lang="scss">
.tab-bar-top-container {
  display: none;
  position: fixed;
  bottom: calc(72px + env(safe-area-inset-bottom, 0px));
  left: 0;
  right: 0;
  padding: 10px;
  text-align: center;
  z-index: 1000;
  width: 100%;
  height: 64px;
  justify-content: space-around;
  align-items: center;

  @media (max-width: 768px) {
    display: flex;
  }

  /* Tam genişlikteki kapsayıcı alttaki içeriğe dokunmayı engellemesin */
  pointer-events: none;

  .tab-bar-top {
    pointer-events: auto;
    position: relative;
    padding: 0;
    border-radius: 9999px;
    background: transparent;

    a {
      position: relative;
      display: inline-flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 9px;
      padding: 10px 20px 10px 16px;
      border-radius: 9999px;
      color: #fff;
      text-decoration: none;
      background: linear-gradient(135deg, #ff1f8f 0%, #c026d3 50%, #7c3aed 100%);
      border: 1px solid rgba(255, 255, 255, 0.28);
      box-shadow: 0 8px 22px rgba(234, 3, 178, 0.45), inset 0 1px 1px rgba(255, 255, 255, 0.35);
      overflow: hidden;
      animation: campaignFloat 3s ease-in-out infinite;

      /* parlama efekti */
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -60%;
        width: 40%;
        height: 100%;
        background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.45), transparent);
        transform: skewX(-20deg);
        animation: campaignShine 3.2s ease-in-out infinite;
      }

      svg {
        width: 22px;
        height: 16px;
        flex-shrink: 0;
        color: #fff;
        filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.6));
      }

      .campaign-pill-label {
        font-family: 'Lexend', sans-serif;
        font-weight: 800;
        font-size: 13px;
        line-height: 1;
        letter-spacing: 0.2px;
        color: #fff;
        margin: 0;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
      }

      .campaign-pill-dot {
        position: absolute;
        top: 7px;
        right: 9px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #fde047;
        box-shadow: 0 0 0 0 rgba(253, 224, 71, 0.7);
        animation: campaignDot 1.6s ease-out infinite;
      }

      &:active { transform: scale(0.96); }
    }
  }
}

@keyframes campaignShine {
  0%, 55% { left: -60%; }
  85%, 100% { left: 130%; }
}

@keyframes campaignFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}

@keyframes campaignDot {
  0% { box-shadow: 0 0 0 0 rgba(253, 224, 71, 0.7); }
  100% { box-shadow: 0 0 0 7px rgba(253, 224, 71, 0); }
}

/* Modern Mobile Bottom Tab Bar (Rush UI) */
.tab-bar {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(17, 23, 43, 0.94);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-top: none !important;
  padding: 6px 6px calc(6px + env(safe-area-inset-bottom, 0px));
  z-index: 1025;
  height: calc(62px + env(safe-area-inset-bottom, 0px));
  box-shadow: 0 -3px 18px rgba(0, 0, 0, 0.4);
  justify-content: space-around;
  align-items: center;

  @media (max-width: 768px) {
    display: flex;
  }

  .tab-link {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    text-decoration: none;
    color: #94a3b8;
    padding: 4px 0;
    transition: all 0.2s ease;
    position: relative;
    user-select: none;

    .tab-icon-wrapper {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 24px;
    }

    .tab-icon {
      stroke: #94a3b8;
      stroke-width: 1.8;
      transition: all 0.2s ease;
    }

    .tab-label {
      font-family: 'Lexend', -apple-system, BlinkMacSystemFont, sans-serif;
      font-weight: 500;
      font-size: 10.5px;
      line-height: 1.2;
      text-align: center;
      color: #94a3b8;
      margin-top: 3px;
      transition: all 0.2s ease;
      white-space: nowrap;
    }

    .tab-badge {
      position: absolute;
      top: -4px;
      right: -8px;
      background: #ea03b2;
      color: #ffffff;
      font-size: 10px;
      font-weight: 700;
      min-width: 16px;
      height: 16px;
      border-radius: 9999px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 4px;
      line-height: 1;
      border: 1.5px solid #11172b;
    }

    /* Dokunmatik ekranda :hover yapışıp kalmasın */
    @media (hover: hover) {
      &:hover {
        color: #ea03b2;

        .tab-icon {
          stroke: #ea03b2;
          transform: translateY(-1px);
        }

        .tab-label {
          color: #ea03b2;
        }
      }
    }

    /* Sadece hesaplanan .active sınıfı: vue-router 3.4 router-link-active sadece query anahtarına
       baktığı için ?tab=... olan üç sekmeyi birden aktif yapıyordu */
    &.active {
      color: #ea03b2;

      .tab-icon {
        stroke: #ea03b2;
        stroke-width: 2.2;
      }

      .tab-label {
        color: #ea03b2;
        font-weight: 700;
      }
    }
  }
}

/* Footer her zaman sayfanın en altında: kısa sayfalarda içerik alanı boşluğu doldurur,
   içerik ile footer arasında da her zaman bir boşluk kalır. */
.vertical-layout.has-app-footer {
  display: flex !important;
  flex-direction: column;
  height: auto !important;
  min-height: 100vh;
  min-height: 100dvh;

  > .app-content {
    flex: 1 0 auto;
    width: 100%;
  }

  > .footer.app-footer-wrap {
    flex-shrink: 0;
    width: 100%;
    margin-top: 48px !important;
  }
}

body.moments-active footer:not(.app-footer-wrap),
body.moments-active .footer:not(.app-footer-wrap),
.is-moments-route footer:not(.app-footer-wrap),
.is-moments-route .footer:not(.app-footer-wrap),
.moments-application footer:not(.app-footer-wrap),
.moments-application .footer:not(.app-footer-wrap) {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  border: none !important;
  border-top: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.header-navbar.navbar-shadow {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.55), 0 4px 25px rgba(234, 3, 178, 0.22) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
}
</style>
